<template>
  <div class="container-warp exam-page">
    <Top-Nav :pageTitle="paperTitle"
             :leftArrow="false"></Top-Nav>
    <!-- 顶部信息 -->
    <div class="top-info van-hairline--bottom">
      <div class="top-info-left">
        <span>{{currentQuestionIndex+1}}</span> / <span>{{questionTotal}}</span>
      </div>
      <div class="top-info-mid">
        <span>总得分:{{ stuExamScore }} / {{ totalScore }}</span>
      </div>
      <div class="top-info-right">
        分值:{{currentQuestionScore}}
      </div>
    </div>
    <!-- 试题内容 -->
    <div class="main-content">
      <Question-exam v-if="currentQuestionData"
                     :questionItem="currentQuestionData"
                     action="view"></Question-exam>
    </div>

    <!-- 底部功能区 -->
    <div class="bottom-func van-hairline--top">
      <div class="bottom-func-left">
        <div class="icon-btn"
             v-preventReClick="1000"
             @click="pageBack">
          <van-icon name="upgrade"
                    size="36"
                    color="#888"
                    class="back-icon" />
          <span class="text-muted">返 回</span>
        </div>
        <div class="icon-btn"
             @click="openPaperOrderDialog">
          <van-icon name="apps-o"
                    size="36"
                    color="#409EFF" />
          <span class="text-primary">答题卡</span>
        </div>
      </div>
      <div class="bottom-func-right">
        <van-button icon="revoke"
                    type="info"
                    class="bottom-func-btn"
                    :disabled="currentQuestionIndex === 0"
                    @click="handlePrevQuestion"></van-button>
        <van-button type="info"
                    class="bottom-func-btn"
                    :disabled="currentQuestionIndex === questionTotal - 1"
                    @click="handleNextQuestion">下一题</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { findEndExamById } from "@/api/exam.js";
import funcDialog from "@/components/BaseFuncDialog/funcDialog";
import QuestionExam from "@/components/QuestionExam/QuestionExam.vue";
export default {
  name: 'DoExam',
  components: { QuestionExam },
  data() {
    return {
      paperTitle: '考试名称',
      examStuId: null,
      totalScore: 0,
      passScore: 0,
      questionTotal: 0, // 题目总数
      currentQuestionIndex: 0, // 当前题目序号
      examPaperModules: []
    }
  },
  computed: {
    currentQuestionData() {
      if (this.examPaperModules.length === 0) return null
      let allQuestions = this.examPaperModules.reduce((pre, cur) => {
        return [...pre, ...cur.questions]
      }, [])
      return allQuestions[this.currentQuestionIndex]
    },
    currentQuestionScore() {
      return this.currentQuestionData?.scoreStr || '0'
    },
    stuExamScore() {
      return this.examPaperModules.reduce((pre, cur) => {
        return pre + cur.questions.reduce((pre, cur) => {
          const scoreStr = Number(cur.answer?.answerScoreStr || 0) || 0
          return pre + scoreStr
        }, 0)
      }, 0)
    }
  },
  created() {
    this.getExamPaperData()
  },
  methods: {
    // 获取考试信息
    async getExamPaperData() {
      const { examStuId } = this.$route.query
      this.examStuId = examStuId

      const params = { examStuId: this.examStuId };
      const { status, data } = await findEndExamById(params);
      if (status == 200) {
        // 赋值考试信息
        this.paperTitle = data.paper.examPaperName;
        this.passScore = data.paper.passScore;
        this.totalScore = data.paper.examScore;

        // 赋值题目数据
        let examPaperModules = data.paper.modules.map(item => {
          // 题目和答案都在questionVM中
          const questList = item.questions.map(quest => {
            // 赋值题目分数
            quest.questionVM.scoreStr = quest.scoreStr;

            // 解决未提交题目答案为空的问题
            if (!quest.answer) {
              quest.answer = { stuAnswer: '' }
            }

            // 处理多选、填空答案
            if ([2, 4].includes(quest.questionType)) {
              quest.answer.stuAnswer = quest.answer.stuAnswer.split(',') || []
            }
            // 赋值题目答案
            quest.questionVM.answer = quest.answer;


            // 赋值题目基础信息
            const copyQuestionBaseData = JSON.parse(JSON.stringify(quest));
            delete copyQuestionBaseData.questionVM;
            delete copyQuestionBaseData.question;
            quest.questionVM.questionBaseData = copyQuestionBaseData;

            return quest.questionVM
          })
          item.questions = [...questList]
          return item
        })

        // 生成题目序号
        let questionOrder = 1;
        examPaperModules.forEach((item) => {
          item.questions.forEach((quest) => {
            quest.itemOrder = questionOrder;
            questionOrder++;
          });
        });
        this.questionTotal = questionOrder - 1;
        console.log(examPaperModules)
        this.examPaperModules = examPaperModules;
      }
    },
    // 答题卡弹窗
    async openPaperOrderDialog() {
      try {
        const cbParams = await funcDialog({
          title: '答题卡',
          dialogAttributes: {
            width: '100%',
            height: '86%',
            position: 'bottom',
            closeable: true
          },
          contentComponent: () => import('@/view/doExam/components/paper-order.vue'),
          dialogParams: { examPaperModules: [...this.examPaperModules], action: 'view' },
        })

        this.currentQuestionIndex = cbParams.currentIndex
      } catch (cbParams) {
        console.log(cbParams)
      }
    },
    // 上一题
    handlePrevQuestion() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
      }
    },
    // 下一题
    handleNextQuestion() {
      if (this.currentQuestionIndex < this.questionTotal) {
        this.currentQuestionIndex++;
      }
    }
  },
}
</script>

<style lang="less" scoped>
@import url("~@/assets/css/exam-page.less");
.back-icon {
  transform: rotate(-90deg);
}
</style>